module.exports = __webpack_public_path__ + "img/20190524103102未标题-1.1d57fc9a.png";